var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, Tile, TileHeader, TileComment } from '../common/Tile';
import { ToolbarWithProps } from '../common/Toolbar';
import { useRouter } from '../../context/router-context';
import { Body } from '../root/PageRouter';
import { Film, Mic } from '@styled-icons/icomoon';
import styled from 'styled-components';
var Icon = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 60px;\n  height: 60px;\n  margin: 0 auto;\n  padding-top: 30px;\n  padding-bottom: 60px;\n  color: rgba(255, 255, 255, 90%);\n"], ["\n  width: 60px;\n  height: 60px;\n  margin: 0 auto;\n  padding-top: 30px;\n  padding-bottom: 60px;\n  color: rgba(255, 255, 255, 90%);\n"])));
export function CommunityTileBody() {
    return (_jsxs(_Fragment, { children: [_jsx(TileHeader, { children: "Community" }, void 0),
            _jsxs(TileComment, { children: ["Explore the latest activities in the Applied AI Community.", _jsx("br", {}, void 0),
                    _jsx("br", {}, void 0), "Keynote talks and discussions from Events, Fireside Chats, Virtual Coffee Breaks, and more."] }, void 0)] }, void 0));
}
export function EventTileBody() {
    return (_jsxs(_Fragment, { children: [_jsx(TileHeader, { children: "Events" }, void 0),
            _jsx(TileComment, { children: "Explore inspirational talks and sessions from Fireside Chats, BootstrapLabs Applied AI Conferences and Applied AI Insiders Series." }, void 0)] }, void 0));
}
function EventTile() {
    return (_jsxs(_Fragment, { children: [_jsx(TileHeader, { children: "Events" }, void 0),
            _jsxs(TileComment, { children: ["Watch inspirational talks and sessions from Applied AI Events. ", _jsx("br", {}, void 0),
                    _jsx("br", {}, void 0), "Videos and contents from BootstrapLabs Applied AI Conferences, Applied AI Insiders Series and more."] }, void 0),
            _jsx(Icon, { children: _jsx(Mic, {}, void 0) }, void 0)] }, void 0));
}
function ContentTile() {
    return (_jsxs(_Fragment, { children: [_jsx(TileHeader, { children: "Content" }, void 0),
            _jsxs(TileComment, { children: ["Explore the latest activities in the community. ", _jsx("br", {}, void 0), " ", _jsx("br", {}, void 0), "Articles, Interviews, Discussions and Fireside Chats by and for the Applied AI Community."] }, void 0),
            _jsx(Icon, { children: _jsx(Film, {}, void 0) }, void 0)] }, void 0));
}
export function Community() {
    // Router
    var _a = useRouter(), goForwardClick = _a.goForwardClick, goBack = _a.goBack;
    return (_jsxs(_Fragment, { children: [_jsx(ToolbarWithProps, __assign({ cancel: { type: 'back', onClick: goBack } }, { children: "Community" }), void 0),
            _jsx(Body, { children: _jsxs(Grid, { children: [_jsx(Tile, __assign({ span: 6, onClick: goForwardClick('/content') }, { children: _jsx(ContentTile, {}, void 0) }), void 0),
                        _jsx(Tile, __assign({ span: 6, onClick: goForwardClick('/events') }, { children: _jsx(EventTile, {}, void 0) }), void 0)] }, void 0) }, void 0)] }, void 0));
}
var templateObject_1;
//# sourceMappingURL=community.js.map